.FormControl {
  display: inline-flex;
  font-family: var(--brand-body-fontFamily);
  flex-direction: column;
  gap: var(--base-size-8);
}

.FormControl--fullWidth {
  width: 100%;
}

.FormControl--checkbox {
  display: grid;
  grid-template-columns: auto 1fr;
}

.FormControl--border {
  border: 1px solid var(--brand-control-color-border-default);
  border-radius: var(--brand-borderRadius-medium);
  padding: var(--base-size-12);
}

.FormControl-label {
  color: var(--brand-color-text-default);
  font-weight: var(--base-text-weight-medium);
  font-family: var(--brand-body-fontFamily);
}

.FormControl-label--visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.FormControl-label--medium {
  letter-spacing: var(--brand-text-letterSpacing-100);
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
}

.FormControl-label--large {
  letter-spacing: var(--brand-text-letterSpacing-300);
  font-size: var(--brand-text-size-300);
  line-height: var(--brand-text-lineHeight-300);
}

.FormControl-label--checkbox {
  cursor: pointer;
  font-size: var(--brand-text-size-100);
  font-weight: var(--base-text-weight-medium);
  line-height: var(--base-size-24);
  width: 100%;
  position: relative;
  top: 1px;
}

.FormControl-control--radio {
  margin: 2px 0 0;
}

.FormControl-hint {
  grid-column: 1 / 3;
  display: block;
}

/*Validation*/
.FormControl-validation {
  display: flex;
  gap: var(--base-size-4);
  align-items: center;
}

.FormControl-validation--success {
  color: var(--brand-color-success-fg);
}

.FormControl-validation--error {
  color: var(--brand-color-danger-fg);
}

.FormControl-validation-success-icon {
  display: flex;
}

.FormControl-validation-error-icon {
  display: flex;
}

.FormControl-validation--animate-in {
  animation: 170ms FormControlValidationFadeIn cubic-bezier(0.44, 0.74, 0.36, 1);
}

@keyframes FormControlValidationFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.FormControl-validation-checkbox {
  grid-column: 1 / 3;
}
